"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rdf_literal_1 = require("rdf-literal");

var sparqljson_parse_1 = require("sparqljson-parse");
/**
 * Converts SPARQL JSON results to a tree-based structure by splitting variables on a certain delimiter.
 */


var Converter =
/*#__PURE__*/
function () {
  function Converter(settings) {
    _classCallCheck(this, Converter);

    settings = settings || {
      delimiter: '_'
    };
    settings.prefixVariableQuestionMark = false;
    this.delimiter = settings.delimiter || '_';
    this.parser = new sparqljson_parse_1.SparqlJsonParser(settings);
    this.materializeRdfJsTerms = settings.materializeRdfJsTerms;
  }
  /**
   * Adds a value to a tree.
   * @param tree A tree datastructure.
   * @param {string[]} path The path of keys in the tree.
   * @param {Term} value A value to add.
   * @param {string} lastKeyPath The accumulated key path (separated by the given delimiter)
   *                             through recursive calls, can be empty.
   * @param {ISchema} schema A schema.
   * @param {string} delimiter The string to join key paths by.
   */


  _createClass(Converter, [{
    key: "sparqlJsonResultsToTree",

    /**
     * Convert a complete SPARQL JSON response to a GraphQL results tree.
     * @param sparqlResponse A SPARQL JSON response.
     * @param {ISchema} schema A schema.
     * @return {any} A GraphQL results tree.
     */
    value: function sparqlJsonResultsToTree(sparqlResponse, schema) {
      return this.bindingsToTree(this.parser.parseJsonResults(sparqlResponse), schema || {
        singularizeVariables: {}
      });
    }
    /**
     * Convert an array of bindings to a GraphQL results tree.
     * @param {IBindings[]} bindingsArray An array of bindings.
     * @param {ISchema} schema A schema.
     * @return {any} A GraphQL results tree.
     */

  }, {
    key: "bindingsToTree",
    value: function bindingsToTree(bindingsArray, schema) {
      var singularRoot = schema && schema.singularizeVariables[''];
      var tree = singularRoot ? {} : [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = bindingsArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var bindings = _step.value;
          var subTree = singularRoot ? {} : [{}];

          for (var key in bindings) {
            var path = key.split(this.delimiter);
            var value = bindings[key];
            Converter.addValueToTree(singularRoot ? subTree : subTree[0], path, value, '', schema, this.delimiter);
          }

          tree = Converter.mergeTrees(tree, subTree).result;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.materializeRdfJsTerms) {
        tree = Converter.materializeTree(tree);
      }

      return tree;
    }
  }], [{
    key: "addValueToTree",
    value: function addValueToTree(tree, path, value, lastKeyPath, schema, delimiter) {
      var key = path[0];
      var keyPath = lastKeyPath ? lastKeyPath + delimiter + key : key;
      var singularize = schema.singularizeVariables[keyPath];

      if (path.length === 1) {
        // Leaf nodes
        if (singularize) {
          if (!tree[key]) {
            tree[key] = value;
          }
        } else {
          if (!tree[key]) {
            tree[key] = [];
          }

          tree[key].push(value);
        }
      } else {
        // Inner nodes
        var nextNode;

        if (singularize) {
          if (!tree[key]) {
            tree[key] = {};
          }

          nextNode = tree[key];
        } else {
          if (!tree[key]) {
            tree[key] = [{}];
          }

          nextNode = tree[key][0];
        }

        Converter.addValueToTree(nextNode, path.slice(1), value, keyPath, schema, delimiter);
      }
    }
    /**
     * Recursively merge the two given trees.
     * @param tree1 A first tree (has key priority on literals).
     * @param tree2 A second tree. All arrays will/should only have a single element.
     * @return {any} The merged tree.
     */

  }, {
    key: "mergeTrees",
    value: function mergeTrees(tree1, tree2) {
      if (typeof tree1 !== typeof tree2) {
        throw new Error("Two incompatible tree nodes were found: ".concat(typeof tree1, " and ").concat(typeof tree2));
      }

      if (Array.isArray(tree1) !== Array.isArray(tree2)) {
        throw new Error("Two incompatible tree nodes were found: Array?".concat(Array.isArray(tree1), " and Array?").concat(Array.isArray(tree2)));
      }

      if (typeof tree1 === 'object' && typeof tree2 === 'object') {
        if (tree1.termType && tree2.termType) {
          if (tree1.equals(tree2)) {
            return {
              valid: true,
              result: tree1
            };
          } else {
            return {
              valid: false,
              result: tree1
            };
          }
        }

        if (Array.isArray(tree1) && Array.isArray(tree2)) {
          if (tree1.length > 0) {
            var merged = [];
            var valid = false;

            for (var i = 0; i < tree1.length; i++) {
              var mergedElement = Converter.mergeTrees(tree1[i], tree2[0]);

              if (mergedElement.valid) {
                valid = true;
                merged.push(mergedElement.result);
              } else {
                merged.push(tree1[i]);
              }
            }

            if (valid) {
              return {
                valid: true,
                result: merged
              };
            }
          }

          return {
            valid: true,
            result: tree1.concat(tree2)
          };
        } else {
          var _merged = {};

          for (var key2 in tree2) {
            _merged[key2] = tree2[key2];
          }

          for (var key1 in tree1) {
            if (_merged[key1]) {
              var _mergedElement = Converter.mergeTrees(tree1[key1], _merged[key1]);

              if (_mergedElement.valid) {
                _merged[key1] = _mergedElement.result;
              } else {
                return {
                  valid: false,
                  result: tree1
                };
              }
            } else {
              _merged[key1] = tree1[key1];
            }
          }

          return {
            valid: true,
            result: _merged
          };
        }
      } else {
        throw new Error("Unmergable tree types: ".concat(typeof tree1, " and ").concat(typeof tree2));
      }
    }
    /**
     * Materialize all RDF terms in the given tree to raw values.
     * This does not mutate the original tree.
     * @param tree A tree.
     * @return {any} A materialized tree.
     */

  }, {
    key: "materializeTree",
    value: function materializeTree(tree) {
      if (tree.termType) {
        return rdf_literal_1.getTermRaw(tree);
      } else if (Array.isArray(tree)) {
        return tree.map(Converter.materializeTree);
      } else {
        var materialized = {};

        for (var key in tree) {
          materialized[key] = Converter.materializeTree(tree[key]);
        }

        return materialized;
      }
    }
  }]);

  return Converter;
}();

exports.Converter = Converter;